import "core-js/stable";
import "regenerator-runtime/runtime";

import Root from "./components/Root";
import React from "react";
import ReactDOM from "react-dom";
import {applyMiddleware, compose, createStore} from "redux";
import {Provider} from "react-redux";
import thunkMiddleware from "redux-thunk";
import reducers from "./reducers";

import GlobalStyle from "./style/globalStyles";
import 'antd/dist/antd.css';

import {initialiseNightlyUpdate} from "./util/appUpdate";

import favicon from "../images/acuris-equities-favicon.ico";

import globalErrorHandler from "./logging/globalErrorHandler";
import logApplicationLoaded from "./logging/logApplicationLoaded";
import {
    logDataFetchedMiddleware, subscriptionDataArrivedMiddleware
} from "./components/subscription/subscriptionActions";
import ProvideFeaturesFromRedux from "./features/ProvideFeaturesFromRedux";

window.onerror = globalErrorHandler;

const middlewares = [thunkMiddleware, logDataFetchedMiddleware(), subscriptionDataArrivedMiddleware()];

initialiseNightlyUpdate();

const middlewareApplication = applyMiddleware(...middlewares);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(middlewareApplication));

const bodyElt = document.body;
const mountElt = document.createElement("div");
mountElt.className = "tim-of-the-future-root";
bodyElt.appendChild(mountElt);

// Set favicon
const link = document.createElement('link');
link.type = 'image/x-icon';
link.rel = 'shortcut icon';
link.href = favicon;
document.getElementsByTagName('head')[0].appendChild(link);

// Add webfonts
const webfontsLink = document.createElement('link');
webfontsLink.rel = 'stylesheet';
webfontsLink.href = "https://fonts.googleapis.com/css?family=Lato:400,700";
document.getElementsByTagName('head')[0].appendChild(webfontsLink);

const browserIsSupported = (navigator.userAgent.toLowerCase().indexOf('msie') !== -1) ? !parseInt(navigator.userAgent.toLowerCase().split('msie')[1]) : true;
if (browserIsSupported) {
    if (process.env.NODE_ENV !== "production" && module.hot) {
        console.log("Enabling hot-reload of React componentry");
        const rerender = () => {
            const NewRoot = require("./components/Root")["default"];
            const NewGlobalStyle = require("./style/globalStyles")["default"];
            ReactDOM.render(<Provider store={store}><ProvideFeaturesFromRedux><React.Fragment><NewRoot /><NewGlobalStyle /></React.Fragment></ProvideFeaturesFromRedux></Provider>, mountElt)
        };
        module.hot.accept("./components/Root", rerender);
        module.hot.accept("./style/globalStyles", rerender);
        module.hot.accept("./reducers", () => {
            const newReducersModule = require("./reducers");
            store.replaceReducer(newReducersModule["default"]);
        });
    }

    ReactDOM.render(<Provider store={store}><ProvideFeaturesFromRedux><React.Fragment><Root /><GlobalStyle /></React.Fragment></ProvideFeaturesFromRedux></Provider>, mountElt);
}
logApplicationLoaded();
